module.exports = __webpack_public_path__ + "static/media/windows.913571ab.svg";